export default "__VITE_ASSET__CC2u8nep__"